import { Component } from 'react';
import { connect } from 'react-redux';
import Router from 'next/router';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';
import { Box } from 'components/common/box';

const GroupDelete = connect((state) => state)(
  class extends Component {
    deleteGroup = async (values) => {
      const {
        pageState: { group }
      } = this.props;

      let url = `/admin/groups/${group.id}`;

      if (values?.deletionReason) {
        const params = new URLSearchParams({
          deletionReason: values.deletionReason
        });
        url += `?${params.toString()}`;
      }

      await api.delete(url);
      Router.push('/groups');
      return true;
    };

    render() {
      const {
        messages,
        serverConfig: { requireReasonWhenDeletingData }
      } = this.props;

      return (
        <div className="delete">
          <Box title={messages.commonDelete}>
            {requireReasonWhenDeletingData ? (
              <ConfirmDeleteButton
                buttonText={messages.groupsDeleteGroup}
                confirmText={messages.groupsDeleteGroupConfirm}
                confirmTitle={messages.groupsDeleteGroup}
                id="deletionReasonGroup"
                onConfirm={this.deleteGroup}
                successMessage={messages.groupsDeleteGroupSuccess}
              />
            ) : (
              <ConfirmButton
                actionText={messages.commonDelete}
                buttonIcon="trash-alt"
                buttonText={messages.groupsDeleteGroup}
                category="danger"
                confirmText={messages.groupsDeleteGroupConfirm}
                confirmTitle={messages.groupsDeleteGroup}
                onConfirm={this.deleteGroup}
                successMessage={messages.groupsDeleteGroupSuccess}
              />
            )}
          </Box>
        </div>
      );
    }
  }
);

export default GroupDelete;
